function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useContext, useMemo } from 'react';
import { Column, Row } from '../Layout/RecordCompareLayout';
import SelectAll from '../SelectAll/RecordCompareSelectAll';
import { formatI18n } from '../../../I18n/I18n/I18n';
import { injectIntl } from 'react-intl';
import UnSelectAll from '../SelectAll/RecordCompareUnSelectAll';
import CompareContext from './RecordCompareContext';
import RecordCompareStateContext from '../../RecordCompareStateContext';
function _ColumnHeader(_ref) {
  var index = _ref.index,
    intl = _ref.intl,
    property = _ref.property,
    rows = _ref.rows,
    title = _ref.title;
  var _useContext = useContext(RecordCompareStateContext),
    selections = _useContext.selections,
    mergeSelections = _useContext.mergeSelections;
  var propertySelections = selections[property];
  var count = useMemo(function () {
    return rows.reduce(function (acc, row) {
      return row[index].hasData ? acc + 1 : acc;
    }, 0);
  }, [rows, index]);
  var handleSelectClick = useCallback(function () {
    var newSelections = rows.reduce(function (acc, row, rowIndex) {
      if (row[index].hasData) {
        acc["r".concat(rowIndex, "-c").concat(index)] = true;
      }
      return acc;
    }, {});
    mergeSelections(_defineProperty({}, property, _objectSpread({}, propertySelections, newSelections)));
  }, [index, rows, mergeSelections, property, propertySelections]);
  var handleUnselectClick = useCallback(function () {
    var newSelections = _objectSpread({}, propertySelections);
    rows.forEach(function (row, rowIndex) {
      return delete newSelections["r".concat(rowIndex, "-c").concat(index)];
    });
    mergeSelections(_defineProperty({}, property, newSelections));
  }, [index, rows, mergeSelections, property, propertySelections]);
  var _useMemo = useMemo(function () {
      var values = {
        count: count,
        title: title,
        index: index + 1
      };
      return [formatI18n(intl, {
        id: '@dm/components.record-compare.labels.select-all-array',
        values: values
      }), formatI18n(intl, {
        id: '@dm/components.record-compare.labels.unselect-all-array',
        values: values
      })];
    }, [intl, count, title, index]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    selectLabel = _useMemo2[0],
    unselectLabel = _useMemo2[1];
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(SelectAll, {
    "aria-label": selectLabel,
    onClick: handleSelectClick
  }), /*#__PURE__*/React.createElement(UnSelectAll, {
    "aria-label": unselectLabel,
    onClick: handleUnselectClick
  }), "(", count, ")");
}
var ColumnHeader = injectIntl(_ColumnHeader);
export default function ArrayHeader(_ref2) {
  var property = _ref2.property,
    rows = _ref2.rows,
    title = _ref2.title;
  var _useContext2 = useContext(CompareContext),
    records = _useContext2.records;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, null), records.map(function (record, index) {
    return /*#__PURE__*/React.createElement(ColumnHeader, {
      key: "header-".concat(property, "-").concat(record.id),
      index: index,
      property: property,
      rows: rows,
      title: title
    });
  })));
}